<template>
	<Modal :title="$t('allReceivablesDetail.transaction.details')"
		   :close-on-click-outside="false"
		   @close="closeModal"
	>
		<template v-slot:body>
			<div class="modal-content flex">
				<div class="text_left flex_1">
					<template v-if="detail.auctionStatus == enumDef.auctionStatus.Sold">
						<md-field displayOnly v-if="detail.startPrice">
							<label>{{ $t("allReceivablesDetail.transaction.startPrice") }}</label>
							<md-input :value="detail.startPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.instantBuyPrice">
							<label>{{ $t("allReceivablesDetail.transaction.fixedPrice") }}</label>
							<md-input :value="detail.instantBuyPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("allReceivablesDetail.assignment.type") }}</label>
							<md-input :value="$t(detail.postTrade)" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("allReceivablesDetail.assignment.sellingPrice") }}</label>
							<md-input :value="detail.soldPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.roi">
							<label>{{ $t("allReceivablesDetail.assignment.roi") }}</label>
							<md-input :value="$t(detail.roi)" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.transactionType">
							<label>{{ $t("common.transactionType") }}</label>
							<md-input :value="detail.transactionType" disabled></md-input>
						</md-field>
					</template>
					<template v-else-if="detail.auctionStatus == enumDef.auctionStatus.Selling">
						<md-field displayOnly>
							<label>{{ $t("common.startTime") }}</label>
							<md-input :value="detail.auctionStartTime" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.endTime") }}</label>
							<md-input :value="detail.auctionEndTime" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.startPrice">
							<label>{{ $t("allReceivablesDetail.transaction.startPrice") }}</label>
							<md-input :value="detail.startPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.instantBuyPrice">
							<label>{{ $t("allReceivablesDetail.transaction.fixedPrice") }}</label>
							<md-input :value="detail.instantBuyPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("allReceivablesDetail.assignment.type") }}</label>
							<md-input :value="$t(detail.postTrade)" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("allReceivablesDetail.transaction.currentBids") }}</label>
							<md-input :value="detail.biddingCount" disabled></md-input>
						</md-field>
					</template>
					<template v-else-if="detail.auctionStatus == enumDef.auctionStatus.Abortive">
						<md-field displayOnly>
							<label>{{ $t("common.startTime") }}</label>
							<md-input :value="detail.auctionStartTime" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.endTime") }}</label>
							<md-input :value="detail.auctionEndTime" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.startPrice">
							<label>{{ $t("allReceivablesDetail.transaction.startPrice") }}</label>
							<md-input :value="detail.startPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="detail.instantBuyPrice">
							<label>{{ $t("allReceivablesDetail.transaction.fixedPrice") }}</label>
							<md-input :value="detail.instantBuyPrice" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("allReceivablesDetail.assignment.type") }}</label>
							<md-input :value="$t(detail.postTrade)" disabled></md-input>
						</md-field>
					</template>

				</div>
			</div>
			<div class="flex flex_end">
				<md-button class="md-blank" @click.stop="closeModal">{{ $t("common.close") }}</md-button>
			</div>
		</template>
	</Modal>
</template>
<script>
import {allReceivablesApi} from "@/common/api/allReceivablesApi";
import Modal from "@/components/templates/modal/Modal";
import {formatAsDecimal, formatAsLocalizedEnum, formatAsMoneyAmount, formatAsLocalizedDate} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
	components: { Modal },
	props: {
		auctionId: { type: Object },
	},
	data() {
		return {
			detail: {},
			enumDef: enumDef
		};
	},
	created() {
		this.loadDetails(this.auctionId);
	},
	methods: {
		closeModal() {
			this.$emit("close");
		},
		loadDetails(auctionId) {
			allReceivablesApi.details({ auctionId })
			.then(res => {
				this.detail = {
					...res,
					startPrice: formatAsMoneyAmount(res.startPrice),
					instantBuyPrice: formatAsMoneyAmount(res.instantBuyPrice),
					soldPrice: formatAsMoneyAmount(res.soldPrice),
					auctionStartTime: formatAsLocalizedDate(res.auctionStartTime),
					auctionEndTime: formatAsLocalizedDate(res.auctionEndTime),
					postTrade: formatAsLocalizedEnum(enumDef.postTradeType, res.postTrade),
					roi: formatAsDecimal(res.roi, { showPercentSign: true, decimals: 4 }),
					transactionType: formatAsLocalizedEnum(enumDef.transactionType, res.transactionType),
				};
			})
			.catch(e => {
				this.toast(e);
			});
		}
	}
};
</script>